import { useState } from "react";
import { MapPin, Mail, MessageSquare, Globe, ShieldCheck } from "lucide-react";
import ContactModal from "@/components/ContactModal";

export const SiteFooter = () => {
  const [showContact, setShowContact] = useState(false);
  return (
    <footer className="bg-slate-900 text-slate-400" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row gap-6 sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <img src="/logo-lg.webp" alt="Smart In" width="36" height="36"
            className="h-9 w-9 rounded-lg object-cover bg-white shadow" />
          <div>
            <p className="text-white font-head font-extrabold text-base leading-none">Smart-In</p>
            <p className="text-xs text-slate-500 mt-1">Workforce attendance, verified by AI</p>
          </div>
        </div>
        <div className="text-sm space-y-1.5 sm:text-right">
          <p className="flex items-start gap-2 sm:justify-end" data-testid="footer-address">
            <MapPin className="h-4 w-4 text-indigo-400 mt-0.5 flex-shrink-0" />
            <span>1330 Coast Village Rd, Suite 210, Santa Barbara, CA 93108, USA</span>
          </p>
          <p className="flex items-center gap-2 sm:justify-end">
            <Mail className="h-4 w-4 text-indigo-400 flex-shrink-0" />
            <a
              data-testid="footer-email"
              href="mailto:qayum2b@gmail.com?subject=Smart-In%20Enquiry"
              className="hover:text-white transition-colors"
            >
              info@smrtin.net
            </a>
          </p>
          <p className="flex items-center gap-2 sm:justify-end">
            <Globe className="h-4 w-4 text-indigo-400 flex-shrink-0" />
            <a
              data-testid="footer-website"
              href="https://smrtin.net"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              smrtin.net
            </a>
          </p>
          <div className="flex items-center gap-5 sm:justify-end pt-1">
            <a
              data-testid="footer-privacy-policy-btn"
              href="https://smrtin.net/privacy"
              className="inline-flex items-center gap-1.5 text-[#FFC400] hover:text-white font-semibold transition-colors"
            >
              <ShieldCheck className="h-4 w-4" /> Privacy Policy
            </a>
            <button
              type="button"
              data-testid="footer-contact-btn"
              onClick={() => setShowContact(true)}
              className="inline-flex items-center gap-1.5 text-indigo-300 hover:text-white font-semibold transition-colors"
            >
              <MessageSquare className="h-4 w-4" /> Contact Us
            </button>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between text-xs text-slate-500">
          <span>© {new Date().getFullYear()} Smart-In. All rights reserved.</span>
          <span>
            <a href="https://smrtin.net/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">
              Privacy Policy
            </a>
            {" · "}
            Terms of Service
          </span>
        </div>
      </div>
      <ContactModal open={showContact} onClose={() => setShowContact(false)} />
    </footer>
  );
};

export default SiteFooter;
